var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiCopilotMagicSmallFill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34 10.18l-1.172 2.153-1.171-2.152a4.739 4.739 0 00-1.843-1.843L2.001 7.167l2.153-1.171a4.739 4.739 0 001.843-1.843L7.168 2 8.34 4.153a4.739 4.739 0 001.843 1.843l2.153 1.17-2.153 1.172a4.739 4.739 0 00-1.843 1.843zm7.44 12.486l1.566-2.858a6.273 6.273 0 012.463-2.463l2.859-1.567-2.859-1.568a6.274 6.274 0 01-2.463-2.462l-1.567-2.86-1.567 2.86a6.273 6.273 0 01-2.463 2.463L8.89 15.777l2.86 1.567a6.272 6.272 0 012.462 2.463l1.567 2.858z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiCopilotMagicSmallFill);
export default __webpack_public_path__ + "e1a0e01d70a86a1199f800edb9334e29.svg";
export { ForwardRef as ReactComponent };